import { BoldTextStyled } from "./boldtext.styles";
import { BoldTextType } from "./boldtext.types";

function BoldText(props: BoldTextType): JSX.Element {
  return <BoldTextStyled {...props}>{props?.text || "--"}</BoldTextStyled>;
}

export default BoldText;
